import { ReactNode } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { colors, radius } from "../data/tokens";

// ------------------------------------------------------------------
// Botão de ação padrão para linhas de tabelas/listas (global).
// Quadrado 36×36, simétrico, com tooltip. Variantes:
//  - default: ação neutra/navegação (azul da marca sobre fundo lavanda)
//  - danger: ação destrutiva (vermelho de ação sobre fundo suave)
// ------------------------------------------------------------------

type ActionIconButtonProps = {
  title: string;
  icon: ReactNode;
  onClick: () => void;
  variant?: "default" | "danger";
  disabled?: boolean;
};

export function ActionIconButton({
  title,
  icon,
  onClick,
  variant = "default",
  disabled = false,
}: ActionIconButtonProps) {
  const danger = variant === "danger";
  return (
    <Tooltip title={title}>
      {/* span permite tooltip mesmo com o botão desabilitado */}
      <span>
        <IconButton
          size="small"
          aria-label={title}
          onClick={onClick}
          disabled={disabled}
          sx={{
            width: 36,
            height: 36,
            borderRadius: `${radius.sm}px`,
            color: danger ? colors.action : colors.primary,
            backgroundColor: danger ? colors.actionSoft : colors.bgContent,
            "&:hover": {
              backgroundColor: danger ? colors.actionSoft : colors.bgContent,
              filter: "brightness(0.94)",
            },
            "&.Mui-disabled": {
              opacity: 0.35,
              backgroundColor: colors.neutral100,
            },
          }}
        >
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  );
}
